/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGTextareaWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CustomProfileFieldsEditor_organization$ref: FragmentReference;
declare export opaque type CustomProfileFieldsEditor_organization$fragmentType: CustomProfileFieldsEditor_organization$ref;
export type CustomProfileFieldsEditor_organization = {|
  +$fragmentRefs: WYSIWYGTextareaWithFeatureFlag_organization$ref,
  +$refType: CustomProfileFieldsEditor_organization$ref,
|};
export type CustomProfileFieldsEditor_organization$data = CustomProfileFieldsEditor_organization;
export type CustomProfileFieldsEditor_organization$key = {
  +$data?: CustomProfileFieldsEditor_organization$data,
  +$fragmentRefs: CustomProfileFieldsEditor_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomProfileFieldsEditor_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGTextareaWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e378377e221ba8877fb1b736ee4e68e0';

module.exports = node;
